/*
 * Shared earliest-delivery date rules for cart calendar and product-page ETA.
 * Cutoff: 2:00 PM Australia/Sydney (14:00:00 still on time).
 * Lead: 1 business day from the processing day.
 * Weekends and public holidays in the delivery state are skipped.
 * Christmas hamper carts can also set minDate (YYYY-MM-DD) and Monday-only weekdays.
 */
(function () {
  var COUNTRY_TIMEZONES = {
    AU: 'Australia/Sydney',
    NZ: 'Pacific/Auckland',
    GB: 'Europe/London',
    UK: 'Europe/London',
    IE: 'Europe/Dublin',
    US: 'America/New_York',
    CA: 'America/Toronto',
    SG: 'Asia/Singapore',
    HK: 'Asia/Hong_Kong',
    JP: 'Asia/Tokyo'
  };

  var STATE_ALIASES = {
    NSW: 'NSW',
    'NEW SOUTH WALES': 'NSW',
    VIC: 'VIC',
    VICTORIA: 'VIC',
    QLD: 'QLD',
    QUEENSLAND: 'QLD',
    SA: 'SA',
    'SOUTH AUSTRALIA': 'SA',
    WA: 'WA',
    'WESTERN AUSTRALIA': 'WA',
    TAS: 'TAS',
    TASMANIA: 'TAS',
    NT: 'NT',
    'NORTHERN TERRITORY': 'NT',
    ACT: 'ACT',
    'AUSTRALIAN CAPITAL TERRITORY': 'ACT'
  };

  /* ymd -> '*' (national) or comma-separated state codes. Source: AU public holidays 2026–2027. */
  var AU_HOLIDAYS = {
    '2026-01-01': '*',
    '2026-01-26': '*',
    '2026-03-02': 'WA',
    '2026-03-09': 'ACT,SA,TAS,VIC',
    '2026-04-03': '*',
    '2026-04-04': 'ACT,NSW,NT,QLD,SA,VIC',
    '2026-04-05': 'ACT,NSW,NT,QLD,SA,VIC,WA',
    '2026-04-06': '*',
    '2026-04-25': 'NT,QLD,SA,TAS,VIC',
    '2026-04-27': 'ACT,NSW,WA',
    '2026-05-04': 'NT,QLD',
    '2026-06-01': 'ACT,WA',
    '2026-06-08': 'ACT,NSW,NT,SA,TAS,VIC',
    '2026-08-03': 'NT',
    '2026-09-25': 'VIC',
    '2026-09-28': 'WA',
    '2026-10-05': 'ACT,NSW,QLD,SA',
    '2026-11-03': 'VIC',
    '2026-12-25': '*',
    '2026-12-28': '*',
    '2027-01-01': '*',
    '2027-01-26': '*',
    '2027-03-01': 'WA',
    '2027-03-08': 'ACT,SA,TAS,VIC',
    '2027-03-26': '*',
    '2027-03-27': 'ACT,NSW,NT,QLD,SA,VIC',
    '2027-03-28': 'ACT,NSW,NT,QLD,SA,VIC,WA',
    '2027-03-29': '*',
    '2027-04-25': 'SA,TAS,VIC',
    '2027-04-26': 'ACT,NSW,NT,QLD,WA',
    '2027-05-03': 'NT,QLD',
    '2027-05-31': 'ACT',
    '2027-06-07': 'WA',
    '2027-06-14': 'ACT,NSW,NT,SA,TAS,VIC',
    '2027-08-02': 'NT',
    '2027-09-24': 'VIC',
    '2027-09-27': 'WA',
    '2027-10-04': 'ACT,NSW,QLD,SA',
    '2027-11-02': 'VIC',
    '2027-12-27': '*',
    '2027-12-28': '*'
  };

  var WEEKDAY_LABELS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  var MONTH_LABELS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  var WEEKDAY_FULL = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function toYmd(date) {
    return date.getUTCFullYear() + '-' + pad(date.getUTCMonth() + 1) + '-' + pad(date.getUTCDate());
  }

  function fromYmd(ymd) {
    var parts = String(ymd).slice(0, 10).split('-').map(Number);
    return new Date(Date.UTC(parts[0], parts[1] - 1, parts[2]));
  }

  function addDays(date, days) {
    var next = new Date(date.getTime());
    next.setUTCDate(next.getUTCDate() + days);
    return next;
  }

  function isoWeekday(date) {
    var day = date.getUTCDay();
    return day === 0 ? 7 : day;
  }

  function normalizeState(value) {
    var raw = String(value || '').trim().toUpperCase().replace(/^AU-/, '');
    if (!raw) return '';
    if (STATE_ALIASES[raw]) return STATE_ALIASES[raw];
    return raw.replace(/[^A-Z]/g, '').slice(0, 3);
  }

  function timezoneForCountry(code) {
    var country = String(code || '').toUpperCase();
    if (COUNTRY_TIMEZONES[country]) return COUNTRY_TIMEZONES[country];
    if (window.Shopify && Shopify.country && COUNTRY_TIMEZONES[String(Shopify.country).toUpperCase()]) {
      return COUNTRY_TIMEZONES[String(Shopify.country).toUpperCase()];
    }
    return 'Australia/Sydney';
  }

  function ymdInTimeZone(date, timeZone) {
    return new Intl.DateTimeFormat('en-CA', {
      timeZone: timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(date);
  }

  function hourInTimeZone(date, timeZone) {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: timeZone,
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(date);
    var hour = 0;
    var minute = 0;
    parts.forEach(function (part) {
      if (part.type === 'hour') hour = parseInt(part.value, 10);
      if (part.type === 'minute') minute = parseInt(part.value, 10);
    });
    return { hour: hour, minute: minute };
  }

  function formatLong(date) {
    return WEEKDAY_FULL[isoWeekday(date) - 1] + ' ' + date.getUTCDate() + ' ' + MONTH_LABELS[date.getUTCMonth()];
  }

  function startOfMonth(date) {
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 1));
  }

  function addMonths(date, months) {
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + months, 1));
  }

  function monthTitle(date) {
    return MONTH_LABELS[date.getUTCMonth()] + ' ' + date.getUTCFullYear();
  }

  function parseWeekdays(value) {
    if (Array.isArray(value)) {
      return value.map(Number).filter(function (n) { return n >= 1 && n <= 7; });
    }
    return String(value || '1,2,3,4,5')
      .split(',')
      .map(function (n) { return parseInt(n, 10); })
      .filter(function (n) { return n >= 1 && n <= 7; });
  }

  function parseExcluded(value) {
    if (Array.isArray(value)) return value.filter(Boolean);
    return String(value || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
  }

  function parseMinYmd(value) {
    var ymd = String(value || '').trim().slice(0, 10);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return '';
    return toYmd(fromYmd(ymd)) === ymd ? ymd : '';
  }

  function createEngine(config) {
    config = config || {};
    var minLeadDays = parseInt(config.minLeadDays, 10);
    if (isNaN(minLeadDays)) minLeadDays = 1;
    var cutoffHour = parseInt(config.cutoffHour, 10);
    if (isNaN(cutoffHour)) cutoffHour = 14;
    var timezone = config.timezone || timezoneForCountry(config.shippingCountry);
    var deliveryState = normalizeState(config.deliveryState);
    var allowedWeekdays = parseWeekdays(config.allowedWeekdays);
    var excludedDates = parseExcluded(config.excludedDates);
    var minDateYmd = parseMinYmd(config.minDate);

    function holidayEntry(ymd) {
      return AU_HOLIDAYS[ymd] || '';
    }

    function isAllowedWeekday(date) {
      return allowedWeekdays.indexOf(isoWeekday(date)) !== -1;
    }

    function isWeekend(date) {
      var day = isoWeekday(date);
      return day === 6 || day === 7;
    }

    function isNationalHoliday(date) {
      return holidayEntry(toYmd(date)) === '*';
    }

    function isStateHoliday(date) {
      var entry = holidayEntry(toYmd(date));
      if (!entry || entry === '*' || !deliveryState) return false;
      return entry.split(',').indexOf(deliveryState) !== -1;
    }

    function isMerchantExcluded(date) {
      return excludedDates.indexOf(toYmd(date)) !== -1;
    }

    function isHoliday(date) {
      return isNationalHoliday(date) || isStateHoliday(date) || isMerchantExcluded(date);
    }

    function isProcessingDay(date) {
      return !isWeekend(date) && !isNationalHoliday(date) && !isMerchantExcluded(date);
    }

    function isDeliveryDay(date) {
      return isAllowedWeekday(date) && !isHoliday(date);
    }

    function nextMatchingDay(date, predicate) {
      var cursor = addDays(date, 1);
      var guard = 0;
      while (!predicate(cursor) && guard < 60) {
        cursor = addDays(cursor, 1);
        guard += 1;
      }
      return cursor;
    }

    function addMatchingDays(date, count, predicate) {
      var cursor = date;
      var added = 0;
      var guard = 0;
      while (added < count && guard < 60) {
        cursor = addDays(cursor, 1);
        if (predicate(cursor)) added += 1;
        guard += 1;
      }
      return cursor;
    }

    function computeProcessingDay(now) {
      var at = now || new Date();
      var todayYmd = ymdInTimeZone(at, timezone);
      var clock = hourInTimeZone(at, timezone);
      var day = fromYmd(todayYmd);
      var pastCutoff = clock.hour > cutoffHour || (clock.hour === cutoffHour && clock.minute > 0);

      if (!isProcessingDay(day)) {
        return nextMatchingDay(day, isProcessingDay);
      }
      if (pastCutoff) {
        return nextMatchingDay(day, isProcessingDay);
      }
      return day;
    }

    function computeFirstEligible(now) {
      var processing = computeProcessingDay(now);
      var first = addMatchingDays(processing, minLeadDays, isDeliveryDay);
      if (!isDeliveryDay(first)) {
        first = nextMatchingDay(addDays(first, -1), isDeliveryDay);
      }
      if (minDateYmd) {
        var floor = fromYmd(minDateYmd);
        if (first.getTime() < floor.getTime()) first = floor;
        if (!isDeliveryDay(first)) {
          first = nextMatchingDay(addDays(first, -1), isDeliveryDay);
        }
      }
      return first;
    }

    function isYmdEligible(ymd, firstEligible) {
      if (!ymd || !firstEligible) return false;
      var date = fromYmd(ymd);
      return isDeliveryDay(date) && date.getTime() >= firstEligible.getTime();
    }

    return {
      minLeadDays: minLeadDays,
      cutoffHour: cutoffHour,
      timezone: timezone,
      deliveryState: deliveryState,
      allowedWeekdays: allowedWeekdays,
      excludedDates: excludedDates,
      minDate: minDateYmd,
      isAllowedWeekday: isAllowedWeekday,
      isWeekend: isWeekend,
      isNationalHoliday: isNationalHoliday,
      isStateHoliday: isStateHoliday,
      isMerchantExcluded: isMerchantExcluded,
      isHoliday: isHoliday,
      isProcessingDay: isProcessingDay,
      isDeliveryDay: isDeliveryDay,
      isYmdEligible: isYmdEligible,
      nextMatchingDay: nextMatchingDay,
      addMatchingDays: addMatchingDays,
      computeProcessingDay: computeProcessingDay,
      computeFirstEligible: computeFirstEligible,
      formatLong: formatLong,
      toYmd: toYmd,
      fromYmd: fromYmd
    };
  }

  window.MHDeliveryDate = {
    COUNTRY_TIMEZONES: COUNTRY_TIMEZONES,
    AU_HOLIDAYS: AU_HOLIDAYS,
    WEEKDAY_LABELS: WEEKDAY_LABELS,
    MONTH_LABELS: MONTH_LABELS,
    toYmd: toYmd,
    fromYmd: fromYmd,
    addDays: addDays,
    isoWeekday: isoWeekday,
    normalizeState: normalizeState,
    timezoneForCountry: timezoneForCountry,
    ymdInTimeZone: ymdInTimeZone,
    hourInTimeZone: hourInTimeZone,
    formatLong: formatLong,
    startOfMonth: startOfMonth,
    addMonths: addMonths,
    monthTitle: monthTitle,
    createEngine: createEngine
  };

  var LOCATION_KEY = 'mh-delivery-location';
  var LEGACY_LOCATION_KEY = 'mh-hamper-postcode';

  function parseStoredJson(raw) {
    if (!raw) return null;
    try {
      var value = typeof raw === 'string' ? JSON.parse(raw) : raw;
      return value && typeof value === 'object' ? value : null;
    } catch (error) {
      return null;
    }
  }

  function normaliseAuPostcode(value) {
    var digits = String(value || '').replace(/\D/g, '').slice(0, 4);
    if (digits.length === 3) {
      var n = parseInt(digits, 10);
      if (n >= 800 && n <= 999) return '0' + digits;
    }
    return digits;
  }

  function normaliseLocation(raw) {
    var data = parseStoredJson(raw);
    if (!data) return null;
    var postcode = normaliseAuPostcode(data.postcode);
    if (postcode.length !== 4) return null;
    var state = normalizeState(data.state || data.province || '');
    var suburb = String(data.suburb || '').trim();
    var deliveryDate = String(data.delivery_date || '').slice(0, 10);
    if (deliveryDate && !/^\d{4}-\d{2}-\d{2}$/.test(deliveryDate)) deliveryDate = '';
    return {
      postcode: postcode,
      suburb: suburb,
      state: state,
      province: state,
      delivery_date: deliveryDate
    };
  }

  function readLocation() {
    try {
      return normaliseLocation(window.localStorage.getItem(LOCATION_KEY))
        || normaliseLocation(window.localStorage.getItem(LEGACY_LOCATION_KEY));
    } catch (error) {
      return null;
    }
  }

  function writeLocation(partial) {
    var current = readLocation() || {};
    var incoming = parseStoredJson(partial) || {};
    var nextPostcode = normaliseAuPostcode(incoming.postcode || current.postcode);
    var currentCode = parseInt(String(current.postcode || '').replace(/\D/g, ''), 10);
    var nextCode = parseInt(nextPostcode, 10);
    var postcodeChanged = !!(current.postcode && nextPostcode && currentCode !== nextCode);
    var next = normaliseLocation({
      postcode: nextPostcode || incoming.postcode || current.postcode,
      suburb: postcodeChanged
        ? (incoming.suburb || '')
        : (incoming.suburb != null && incoming.suburb !== '' ? incoming.suburb : current.suburb),
      state: postcodeChanged
        ? (incoming.state || incoming.province || '')
        : (incoming.state || incoming.province || current.state),
      province: postcodeChanged
        ? (incoming.province || incoming.state || '')
        : (incoming.province || incoming.state || current.province),
      delivery_date: incoming.delivery_date || current.delivery_date
    });
    if (!next) return null;
    try {
      window.localStorage.setItem(LOCATION_KEY, JSON.stringify(next));
      window.localStorage.removeItem(LEGACY_LOCATION_KEY);
    } catch (error) {
      /* ignore quota / private mode */
    }
    return next;
  }

  window.MHDeliveryLocation = {
    KEY: LOCATION_KEY,
    read: readLocation,
    write: writeLocation,
    normalise: normaliseLocation
  };
})();
